<template>
	<div
		v-if="readingTime > 0"
		class="readtime"
	>
		<span>
			{{ readingTime }} {{ readDescription }}
		</span>
	</div>
</template>
<script>
export default {
	name: 'ReadingTime',
	props: {
		htmlContent: {
			type: String,
			default: null,
		},
		lang: {
			type: String,
			default: null,
		},
	},

	data() {
		return {
			readingTime: '',
			readDescription: 'min read',
		};
	},
	computed: {
		strippedHtml() {
			const wpm = 250;
			const words = this.htmlContent.trim(this.htmlContent.replace(/ +(?= )/g, '')).split(' ').length;
			return Math.ceil(words / wpm);
		},
	},

	created() {
		this.readingTime = this.strippedHtml;

		if (this.lang && this.lang === 'es_ES') {
			this.readDescription = 'minutos de lectura';
		}
	},

};
</script>
<style lang="scss">
@import '../stylesheets/_variables.scss';

.readtime {
	color: $dark-grey-new;
	font-family: $base-font-family-sans;
	font-size: px2rem(12);
	font-weight: 400;
	line-height: px2rem(16.8);
	margin-bottom: px2rem(12);

	@media (min-width: $small-desktop) {
		font-size: px2rem(14);
	}
}
</style>
